import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
import axios from "axios";
import "./discounts.css";

const ServiceNotes = () => {
  const navigate = useNavigate();
  // const serviceType = useSelector((state) => state.service.serviceType);
  const [discountData, setDiscountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDiscountData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://api.generalhome.sa/api/Themes/GetSlider/clean"
        );

        if (response.data) {
          setDiscountData(response.data);
        } else {
          // Create fallback data if API returns empty
          setDiscountData({
            text1: "عروض وتخفيضات حصرية",
            text2:
              "- خصم 20% على خدمة التنظيف الأولى\n- صيانة مجانية لمدة 3 أشهر\n- تركيب مجاني للقطع التالفة\n- خصم 15% للعملاء الدائمين",
            note: "ملاحظة:\n- العروض سارية حتى نهاية الشهر\n- يمكن دمج العروض مع بعضها\n- للحجز يرجى الاتصال على الرقم 0555555555",
            image:
              "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          });
        }
      } catch (error) {
        console.error("Error fetching discount data:", error);
        setError("فشل في تحميل بيانات العروض");
        // Set fallback data on error
        setDiscountData({
          text1: "عروض وتخفيضات حصرية",
          text2:
            "- خصم 20% على خدمة التنظيف الأولى\n- صيانة مجانية لمدة 3 أشهر\n- تركيب مجاني للقطع التالفة\n- خصم 15% للعملاء الدائمين",
          note: "ملاحظة:\n- العروض سارية حتى نهاية الشهر\n- يمكن دمج العروض مع بعضها\n- للحجز يرجى الاتصال على الرقم 0555555555",
          image:
            "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDiscountData();
  }, []);

  const handleNextClick = () => {
    navigate("/VerifiyMobileNumber");
  };

  const formatNotes = (notesText) => {
    return notesText.split("\n").map((note, index) => (
      <div key={index} className="note-item">
        <div className="note-icon-container">
          <span className="note-icon">!</span>
        </div>
        <p>{note.replace("- ", "").trim()}</p>
      </div>
    ));
  };

  if (loading) {
    return (
      <div className="maintainanceNotes">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
        <div className="maintainanceNotes-container container">
          <div className="loading-wrapper">
            <div className="loading-spinner"></div>
            <p>جاري تحميل البيانات...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="maintainanceNotes">
      {/* Animated background shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
      </div>

      {/* Decorative corner elements */}
      <div className="corner-decor top-left"></div>
      <div className="corner-decor top-right"></div>
      <div className="corner-decor bottom-left"></div>
      <div className="corner-decor bottom-right"></div>

      <div className="maintainanceNotes-container container">
        <div className="maintenance-header">
          <h1 className="slide-in-right">{discountData.text1}</h1>
          <div className="header-divider scale-in"></div>
          <p className="subheading fade-in">لضمان سلامتك وكفاءة خدمة الصيانة</p>
        </div>

        <div className="maintenance-content">
          <div className="maintenance-image-section slide-in-left">
            <div className="image-frame">
              <img
                src={discountData.image}
                alt="Maintenance Notes"
                className="maintenance-image"
                onError={(e) => {
                  e.target.src =
                    "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1169&q=80";
                }}
              />
            </div>
          </div>

          <div className="notes-section fade-in-up">
            <div className="notes-card">
              <div className="notes-header">
                <h2>{discountData.text2}</h2>
                <div className="notes-icon">📝</div>
              </div>
              <div className="notes-container">
                {formatNotes(discountData.note)}
              </div>
            </div>
          </div>
        </div>

        <div className="proceed-button-container fade-in-up">
          <button className="proceed-button" onClick={handleNextClick}>
            المتابعة إلى حجز خدمه التنظيف
            <span className="button-arrow">←</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceNotes;
